import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const ResetButton = styled(Button)({
  color: '#061923',
  fontWeight: 500,
  fontSize: 13,
  textTransform: 'uppercase',
  padding: '4px 12px',
  minWidth: 'auto',
  '&:hover': {
    backgroundColor: 'rgba(6, 25, 35, 0.08)'
  }
});
